module.exports = __webpack_public_path__ + "static/media/wrench.79bed35a.svg";